import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { User } from '..';

export class Cliente {
  public idCliente: number;
  public razaoSocial: string;
  public nomeFantasia: string;
  public cnpjCPF: string;
  public inscricaoEstadual: string;
  public email: string;
  public telefone: string;
  public celular: string;
  public observacoes: string;
  public idVendedor: number;

  constructor() {
    this.idCliente = 0;
    this.razaoSocial = '';
    this.nomeFantasia = '';
    this.cnpjCPF = '';
    this.inscricaoEstadual = '';
    this.email = '';
    this.telefone = '';
    this.celular = '';
    this.observacoes = '';
    this.idVendedor = 0;
  }
}

@Injectable()
export class ClienteProvider {
  constructor(public api: Api, private user: User) {}

  gets(pagination) {
    return this.api.gets('cliente/gets', pagination);
  }

  get(idCliente) {
    return this.api.get('cliente/get', idCliente);
  }

  post(cliente: Cliente) {
    cliente.idVendedor = this.user.user.idVendedor;
    return this.api.post('cliente/add', cliente);
  }

  put(cliente: Cliente) {
    cliente.idVendedor = this.user.user.idVendedor;
    return this.api.put('cliente/edit', cliente);
  }

  noRepeat(cnpj) {
    return this.api.get('cliente/noDoppelganger', cnpj);
  }

}



// WEBPACK FOOTER //
// ./src/providers/cliente/cliente.ts